import React, { useMemo, createContext, useState, ReactNode } from 'react';
import { getAll } from 'firebase/remote-config';
import parseRemoteData from 'helpers/utils/parseRemoteData';
import { mainRemoteConfig } from 'config/firebase';
import { defaultValues } from '@globalConstants';

type RemoteConfigObject = Record<string, string | number | boolean>;
interface RemoteConfigContextType {
  remoteConfigState: RemoteConfigObject;
  remoteConfigActions: {
    setAllValues: () => void;
  };
}
export const RemoteConfigContext = createContext<RemoteConfigContextType | undefined>(undefined);
/**
 *
 * @param {object} props
 * @param {React.Component}props.children
 * @returns {React.ReactElement}  Remote Config context provider, manages the values from Remote Config
 */
export default function RemoteConfigContextProvider({ children }: { children: ReactNode }) {
  const [remoteConfigState, setRemoteConfigState] = useState<RemoteConfigObject>(defaultValues);
  const remoteConfigActions = useMemo(() => {
    /**
     * Set enabled all values of Remote Config in context State
     */
    const setAllValues = () => {
      const allValues = getAll(mainRemoteConfig);
      setRemoteConfigState(parseRemoteData(allValues));
    };
    return {
      setAllValues,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RemoteConfigContext.Provider value={{ remoteConfigState, remoteConfigActions }}>
      {children}
    </RemoteConfigContext.Provider>
  );
}
